import { Download } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTranslation } from 'react-i18next'
import {
  downloadTranscript,
  type TranscriptExportFormat,
} from '@/utils/transcriptExport'

interface ExportMenuProps {
  markdown: string
  title: string
  disabled?: boolean
}

const FORMATS: { format: TranscriptExportFormat; labelKey: string; labelDefault: string }[] = [
  { format: 'txt', labelKey: 'user_artifact.export.txt', labelDefault: 'Plain Text (.txt)' },
  { format: 'md', labelKey: 'user_artifact.export.md', labelDefault: 'Markdown (.md)' },
  { format: 'doc', labelKey: 'user_artifact.export.doc', labelDefault: 'Word (.doc)' },
]

/** Download dropdown for the call-transcript viewer (FS-557). */
export function ExportMenu({ markdown, title, disabled }: ExportMenuProps) {
  const { t } = useTranslation('document_viewer')

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          disabled={disabled}
          title={t('user_artifact.download', { defaultValue: 'Download' })}
          aria-label={t('user_artifact.download', { defaultValue: 'Download' })}
        >
          <Download className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {FORMATS.map(({ format, labelKey, labelDefault }) => (
          <DropdownMenuItem
            key={format}
            onClick={() => downloadTranscript(markdown, title, format)}
          >
            {t(labelKey, { defaultValue: labelDefault })}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ExportMenu
